import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { VerticalExpander } from '@adc/ui-core'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const StepForm = ({
  pages = [],
  header: Header = () => null,
  elmId = 'step_form',
}) => {
  const [step, setStep] = useState(0)
  const nextStep = () => setStep(step + 1)
  const backStep = () => setStep(step - 1)
  if (pages.length <= step) return null
  const currentPage = pages[step]
  const pageProps = {
    step,
    nextStep,
    backStep,
    currentPage,
    pages,
  }

  return (
    <div>
      <Header {...pageProps} />
      <div
        className={cx('form-pages')}
        data-elm-id={elmId}
        style={{
          transform: `translateX(${step * (-100 / pages.length)}%)`,
          width: `${pages.length * 100}%`,
        }}
      >
        {pages.map(
          (
            {
              component: Component,
              skippable: questionSkippable = true,
              ...options
            },
            i
          ) => (
            <div
              className={cx('form-page', 'large', {
                hidden: i !== step,
              })}
              data-elm-id={`${elmId}_page_${i}`}
              style={{ width: `${100 / pages.length}%` }}
              key={i}
            >
              <VerticalExpander>
                <Component {...pageProps} {...options} />
              </VerticalExpander>
            </div>
          )
        )}
      </div>
    </div>
  )
}

StepForm.propTypes = {
  pages: PropTypes.array.isRequired,
  header: PropTypes.func,
  elmId: PropTypes.string,
  skippable: PropTypes.bool,
}

export default StepForm
